import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const arrToStr = (arr) => arr?.map((a) => a.value)?.join(',')

export const usePersistedFiltersMultiSelect = ({ options, onFilterChange }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getInitialFilters = () => {
    const initial = {}
    options.forEach(({ key, options, isMulti }) => {
      if (isMulti) {
        const urlValue = searchParams.get(key)?.split(',')
        if (urlValue && urlValue.length) {
          initial[key] = []
          for (var val of urlValue) {
            const matchedOption = options.find((opt) => opt.value === val)
            if (matchedOption) {
              initial[key].push(matchedOption)
            }
          }
        } else {
          const matchedOptions = options.filter((opt) => opt.default)
          for (var matchedOption of matchedOptions) {
            if (matchedOption) {
              if (!initial[key]) {
                initial[key] = []
              }
              initial[key].push(matchedOption)
            }
          }
        }
      } else {
        const urlValue = searchParams.get(key)
        const matchedOption = options.find((opt) => opt.value === urlValue)
        initial[key] = matchedOption ?? options.find((opt) => opt.default) ?? options[0]
      }
    })

    return initial
  }

  const [filters, setFilters] = useState(getInitialFilters)

  useEffect(() => {
    const params = new URLSearchParams(searchParams)
    Object.entries(filters).forEach(([key, val]: any) => {
      if (Array.isArray(val)) {
        if (!val) params.delete(key)
        else params.set(key, val ? arrToStr(val) : '')
        //todo
      } else {
        const defaultValue =
          options.find((opt) => opt.key === key).options.find((opt) => opt.default)?.value ??
          options.find((opt) => opt.key === key)?.options[0].value

        if (val.value === defaultValue) params.delete(key)
        else params.set(key, val?.value ?? '')
      }
    })
    setSearchParams(params, { replace: true })
  }, [filters])

  const handleFilterChange = (key: string, selectedOptions: any) => {
    setFilters((prev) => ({ ...prev, [key]: selectedOptions }))
    onFilterChange([key], selectedOptions)
  }

  return {
    filters,
    handleFilterChange,
  }
}
